var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"airport"}},[_c('circle',{attrs:{"fill":"currentColor","cx":_vm.airport.coordinates.x,"cy":_vm.airport.coordinates.y,"r":_vm.active ? 8 : 6,"id":_vm.airport.code},on:{"mouseover":_vm.emitData}})])}
var staticRenderFns = []

export { render, staticRenderFns }